function e(e, t) {
    t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
    var n = new RegExp("[?&]" + e + "(=(#?[^&#]*(?:#(?=&))?))").exec(t);
    if (!n) return null;
    if (!n[2]) return "";
    var o = n[2];
    return /#(\w)*([^#])$/g.test(o) && (n[2] = o + "#"), decodeURIComponent(n[2].replace(/\+/g, " "))
}

var C = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
    }
    return e
},
    v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e
    } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    };

function e(e, t) {
    t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
    var n = new RegExp("[?&]" + e + "(=(#?[^&#]*(?:#(?=&))?))").exec(t);
    if (!n) return null;
    if (!n[2]) return "";
    var o = n[2];
    return /#(\w)*([^#])$/g.test(o) && (n[2] = o + "#"), decodeURIComponent(n[2].replace(/\+/g, " "))
} ! function (e, t) {
    "object" === ("undefined" == typeof exports ? "undefined" : v(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.LazyLoad = t()
}(this, function () {
    "use strict";

    function n(e, t, n) {
        
        var o, i, a, s, r, l, c, d, u, m, f = t._settings;
        !n && h(e) || (b(f.callback_enter, e), -1 < I.indexOf(e.tagName) && (r = t, l = function e(t) {
            S(t, !0, r), L(s, e, c)
        }, m = c = function e(t) {
            S(t, !1, r), L(s, l, e)
        }, E(d = s = e, "load", u = l), E(d, "loadeddata", u), E(d, "error", m), y(e, f.class_loading)), function (e, t) {
            var n = t._settings,
                o = e.tagName,
                i = w[o];
            if (i) return i(e, n), t._updateLoadingCount(1), t._elements = (a = t._elements, s = e, a.filter(function (e) {
                return e !== s
            }));
            var a, s;
            ! function (e, t) {
                var n = _ && t.to_webp,
                    o = p(e, t.data_src),
                    i = p(e, t.data_bg);
                if (o) {
                    var a = v(o, n);
                    e.style.backgroundImage = 'url("' + a + '")'
                }
                if (i) {
                    var s = v(i, n);
                    e.style.backgroundImage = s
                }
            }(e, n)
        }(e, t), o = e, a = "data-" + "was-processed", null !== (i = "true") ? o.setAttribute(a, i) : o.removeAttribute(a), b(f.callback_set, e))
    }
    var e, p = function (e, t) {
        return e.getAttribute("data-" + t)
    },
        h = function (e) {
            return "true" === p(e, "was-processed")
        },
        o = function (e) {
            return e.getBoundingClientRect().top + window.pageYOffset - e.ownerDocument.documentElement.clientTop
        },
        u = function (e, t, n) {
            return (t === window ? window.innerHeight + window.pageYOffset : o(t) + t.offsetHeight) <= o(e) - n
        },
        i = function (e) {
            return e.getBoundingClientRect().left + window.pageXOffset - e.ownerDocument.documentElement.clientLeft
        },
        m = function (e, t, n) {
            var o = window.innerWidth;
            return (t === window ? o + window.pageXOffset : i(t) + o) <= i(e) - n
        },
        f = function (e, t, n) {
            return (t === window ? window.pageYOffset : o(t)) >= o(e) + n + e.offsetHeight
        },
        g = function (e, t, n) {
            return (t === window ? window.pageXOffset : i(t)) >= i(e) + n + e.offsetWidth
        },
        a = function (e, t) {
            var n, o = new e(t);
            try {
                n = new CustomEvent("LazyLoad::Initialized", {
                    detail: {
                        instance: o
                    }
                })
            } catch (e) {
                (n = document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized", !1, !1, {
                    instance: o
                })
            }
            window.dispatchEvent(n)
        },
        v = function (e, t) {
            return t ? e.replace(/\.(jpe?g|png)/gi, ".webp") : e
        },
        t = "undefined" != typeof window,
        s = t && !("onscroll" in window) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),
        c = t && "classList" in document.createElement("p"),
        _ = t && (!(!(e = document.createElement("canvas")).getContext || !e.getContext("2d")) && 0 === e.toDataURL("image/webp").indexOf("data:image/webp")),
        y = function (e, t) {
            c ? e.classList.add(t) : e.className += (e.className ? " " : "") + t
        },
        l = function (e, t, n, o) {
            for (var i, a = 0; i = e.children[a]; a += 1)
                if ("SOURCE" === i.tagName) {
                    var s = p(i, n);
                    d(i, t, s, o)
                }
        },
        d = function (e, t, n, o) {
            n && e.setAttribute(t, v(n, o))
        },
        w = {
            IMG: function (e, t) {
                var n = _ && t.to_webp,
                    o = t.data_srcset,
                    i = e.parentNode;
                i && "PICTURE" === i.tagName && l(i, "srcset", o, n);
                var a = p(e, t.data_sizes);
                d(e, "sizes", a);
                var s = p(e, o);
                d(e, "srcset", s, n);
                var r = p(e, t.data_src);
                d(e, "src", r, n)
            },
            IFRAME: function (e, t) {
                var n = p(e, t.data_src);
                d(e, "src", n)
            },
            VIDEO: function (e, t) {
                var n = t.data_src,
                    o = p(e, n);
                l(e, "src", n), d(e, "src", o), e.load()
            }
        },
        b = function (e, t) {
            e && e(t)
        },
        E = function (e, t, n) {
            e.addEventListener(t, n)
        },
        r = function (e, t, n) {
            e.removeEventListener(t, n)
        },
        L = function (e, t, n) {
            r(e, "load", t), r(e, "loadeddata", t), r(e, "error", n)
        },
        S = function (e, t, n) {
            var o, i, a = n._settings,
                s = t ? a.class_loaded : a.class_error,
                r = t ? a.callback_load : a.callback_error,
                l = e.target;
            o = l, i = a.class_loading, c ? o.classList.remove(i) : o.className = o.className.replace(new RegExp("(^|\\s+)" + i + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, ""), y(l, s), b(r, l), n._updateLoadingCount(-1)
        },
        I = ["IMG", "IFRAME", "VIDEO"],
        T = function (e) {
            this._settings = C({}, {
                elements_selector: "img",
                container: window,
                threshold: 300,
                throttle: 150,
                data_src: "src",
                data_srcset: "srcset",
                data_sizes: "sizes",
                data_bg: "bg",
                class_loading: "loading",
                class_loaded: "loaded",
                class_error: "error",
                class_initial: "initial",
                skip_invisible: !0,
                callback_load: null,
                callback_error: null,
                callback_set: null,
                callback_enter: null,
                callback_finish: null,
                to_webp: !1
            }, e), this._loadingCount = 0, this._queryOriginNode = this._settings.container === window ? document : this._settings.container, this._previousLoopTime = 0, this._loopTimeout = null, this._boundHandleScroll = this.handleScroll.bind(this), this._isFirstLoop = !0, window.addEventListener("resize", this._boundHandleScroll), this.update()
        };
    return T.prototype = {
        _loopThroughElements: function (e) {
            var t, n, o, i = this._settings,
                a = this._elements,
                s = a ? a.length : 0,
                r = void 0,
                l = [],
                c = this._isFirstLoop;
            if (c && (this._isFirstLoop = !1), 0 !== s) {
                for (r = 0; r < s; r++) {
                    var d = a[r];
                    i.skip_invisible && null === d.offsetParent || (e || (t = d, n = i.container, o = i.threshold, !(u(t, n, o) || f(t, n, o) || m(t, n, o) || g(t, n, o)))) && (c && y(d, i.class_initial), this.load(d), l.push(r))
                } ! function (e, t) {
                    for (; t.length;) e.splice(t.pop(), 1)
                }(a, l)
            } else this._stopScrollHandler()
        },
        _startScrollHandler: function () {
            this._isHandlingScroll || (this._isHandlingScroll = !0, this._settings.container.addEventListener("scroll", this._boundHandleScroll))
        },
        _stopScrollHandler: function () {
            this._isHandlingScroll && (this._isHandlingScroll = !1, this._settings.container.removeEventListener("scroll", this._boundHandleScroll))
        },
        _updateLoadingCount: function (e) {
            this._loadingCount += e, 0 === this._elements.length && 0 === this._loadingCount && b(this._settings.callback_finish)
        },
        handleScroll: function () {
            var e = this._settings.throttle;
            if (0 !== e) {
                var t = Date.now(),
                    n = e - (t - this._previousLoopTime);
                n <= 0 || e < n ? (this._loopTimeout && (clearTimeout(this._loopTimeout), this._loopTimeout = null), this._previousLoopTime = t, this._loopThroughElements()) : this._loopTimeout || (this._loopTimeout = setTimeout(function () {
                    this._previousLoopTime = Date.now(), this._loopTimeout = null, this._loopThroughElements()
                }.bind(this), n))
            } else this._loopThroughElements()
        },
        loadAll: function () {
            this._loopThroughElements(!0)
        },
        update: function (e) {
            var t = this._settings,
                n = e || this._queryOriginNode.querySelectorAll(t.elements_selector);
            this._elements = Array.prototype.slice.call(n).filter(function (e) {
                return !h(e)
            }), s ? this.loadAll() : (this._loopThroughElements(), this._startScrollHandler())
        },
        destroy: function () {
            window.removeEventListener("resize", this._boundHandleScroll), this._loopTimeout && (clearTimeout(this._loopTimeout), this._loopTimeout = null), this._stopScrollHandler(), this._elements = null, this._queryOriginNode = null, this._settings = null
        },
        load: function (e, t) {
            n(e, this, t)
        }
    }, t && function (e, t) {
        if (t)
            if (t.length)
                for (var n, o = 0; n = t[o]; o += 1) a(e, n);
            else a(e, t)
    }(T, window.lazyLoadOptions), T
}),
    function (e, t) {
        "function" == typeof define && define.amd ? define([], function () {
            return t(e)
        }) : "object" == typeof exports ? module.exports = t(e) : e.SmoothScroll = t(e)
    }("undefined" != typeof global ? global : "undefined" != typeof window ? window : this, function (C) {
        "use strict";
        var O = {
            ignore: "[data-scroll-ignore]",
            header: null,
            topOnEmptyHash: !0,
            speed: 500,
            speedAsDuration: !1,
            durationMax: null,
            durationMin: null,
            clip: !0,
            offset: 0,
            easing: "easeInOutCubic",
            customEasing: null,
            updateURL: !0,
            popstate: !0,
            emitEvents: !0
        },
            k = function () {
                var n = {};
                return Array.prototype.forEach.call(arguments, function (e) {
                    for (var t in e) {
                        if (!e.hasOwnProperty(t)) return;
                        n[t] = e[t]
                    }
                }), n
            },
            r = function (t) {
                var n;
                try {
                    n = decodeURIComponent(t)
                } catch (e) {
                    n = t
                }
                return n
            },
            l = function (e) {
                "#" === e.charAt(0) && (e = e.substr(1));
                for (var t, n = String(e), o = n.length, i = -1, a = "", s = n.charCodeAt(0); ++i < o;) {
                    if (0 === (t = n.charCodeAt(i))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
                    a += 1 <= t && t <= 31 || 127 == t || 0 === i && 48 <= t && t <= 57 || 1 === i && 48 <= t && t <= 57 && 45 === s ? "\\" + t.toString(16) + " " : 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? n.charAt(i) : "\\" + n.charAt(i)
                }
                var r;
                try {
                    r = decodeURIComponent("#" + a)
                } catch (e) {
                    r = "#" + a
                }
                return r
            },
            H = function () {
                return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight)
            },
            M = function (e) {
                return e ? (t = e, parseInt(C.getComputedStyle(t).height, 10) + e.offsetTop) : 0;
                var t
            },
            x = function (e, t, n, o) {
                if (t.emitEvents && "function" == typeof C.CustomEvent) {
                    var i = new CustomEvent(e, {
                        bubbles: !0,
                        detail: {
                            anchor: n,
                            toggle: o
                        }
                    });
                    document.dispatchEvent(i)
                }
            };
        return function (o, e) {
            var E, i, L, S, t, I, T = {
                cancelScroll: function (e) {
                    cancelAnimationFrame(I), I = null, e || x("scrollCancel", E)
                }
            };
            T.animateScroll = function (s, r, e) {
                var t, n, o, i, a, l = k(E || O, e || {}),
                    c = "[object Number]" === Object.prototype.toString.call(s),
                    d = c || !s.tagName ? null : s;
                if (c || d) {
                    var u = C.pageYOffset;
                    l.header && !L && (L = document.querySelector(l.header)), S || (S = M(L));
                    var m, f, p, h = c ? s : function (e, t, n, o) {
                        var i = 0;
                        if (e.offsetParent)
                            for (; i += e.offsetTop, e = e.offsetParent;);
                        return i = Math.max(i - t - n, 0), o && (i = Math.min(i, H() - C.innerHeight)), i
                    }(d, S, parseInt("function" == typeof l.offset ? l.offset(s, r) : l.offset, 10), l.clip),
                        g = h - u,
                        v = H(),
                        _ = 0,
                        y = (o = g, a = (i = l).speedAsDuration ? i.speed : Math.abs(o / 1e3 * i.speed), i.durationMax && a > i.durationMax ? i.durationMax : i.durationMin && a < i.durationMin ? i.durationMin : a),
                        w = function (e, t) {
                            var n, o, i, a = C.pageYOffset;
                            if (e == t || a == t || (u < t && C.innerHeight + a) >= v) return T.cancelScroll(!0), o = t, i = c, 0 === (n = s) && document.body.focus(), i || (n.focus(), document.activeElement !== n && (n.setAttribute("tabindex", "-1"), n.focus(), n.style.outline = "none"), C.scrollTo(0, o)), x("scrollStop", l, s, r), !(I = m = null)
                        },
                        b = function (e) {
                            var t, n, o;
                            m || (m = e), f = (_ += e - m) / parseInt(y, 10), p = u + g * (n = f = 1 < f ? 1 : f, "easeInQuad" === (t = l).easing && (o = n * n), "easeOutQuad" === t.easing && (o = n * (2 - n)), "easeInOutQuad" === t.easing && (o = n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1), "easeInCubic" === t.easing && (o = n * n * n), "easeOutCubic" === t.easing && (o = --n * n * n + 1), "easeInOutCubic" === t.easing && (o = n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1), "easeInQuart" === t.easing && (o = n * n * n * n), "easeOutQuart" === t.easing && (o = 1 - --n * n * n * n), "easeInOutQuart" === t.easing && (o = n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n), "easeInQuint" === t.easing && (o = n * n * n * n * n), "easeOutQuint" === t.easing && (o = 1 + --n * n * n * n * n), "easeInOutQuint" === t.easing && (o = n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n), t.customEasing && (o = t.customEasing(n)), o || n), C.scrollTo(0, Math.floor(p)), w(p, h) || (I = C.requestAnimationFrame(b), m = e)
                        };
                    0 === C.pageYOffset && C.scrollTo(0, 0), t = s, n = l, c || history.pushState && n.updateURL && history.pushState({
                        smoothScroll: JSON.stringify(n),
                        anchor: t.id
                    }, document.title, t === document.documentElement ? "#top" : "#" + t.id), x("scrollStart", l, s, r), T.cancelScroll(!0), C.requestAnimationFrame(b)
                }
            };
            var n = function (e) {
                if (!("matchMedia" in C && C.matchMedia("(prefers-reduced-motion)").matches) && 0 === e.button && !e.metaKey && !e.ctrlKey && "closest" in e.target && (i = e.target.closest(o)) && "a" === i.tagName.toLowerCase() && !e.target.closest(E.ignore) && i.hostname === C.location.hostname && i.pathname === C.location.pathname && /#/.test(i.href)) {
                    var t = l(r(i.hash)),
                        n = E.topOnEmptyHash && "#" === t ? document.documentElement : document.querySelector(t);
                    (n = n || "#top" !== t ? n : document.documentElement) && (e.preventDefault(), T.animateScroll(n, i))
                }
            },
                a = function (e) {
                    if (null !== history.state && history.state.smoothScroll && history.state.smoothScroll === JSON.stringify(E) && history.state.anchor) {
                        var t = document.querySelector(l(r(history.state.anchor)));
                        t && T.animateScroll(t, null, {
                            updateURL: !1
                        })
                    }
                },
                s = function (e) {
                    t || (t = setTimeout(function () {
                        t = null, S = M(L)
                    }, 66))
                };
            return T.destroy = function () {
                E && (document.removeEventListener("click", n, !1), C.removeEventListener("resize", s, !1), C.removeEventListener("popstate", a, !1), T.cancelScroll(), I = t = S = L = i = E = null)
            }, T.init = function (e) {
                if (!("querySelector" in document && "addEventListener" in C && "requestAnimationFrame" in C && "closest" in C.Element.prototype)) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
                T.destroy(), E = k(O, e || {}), L = E.header ? document.querySelector(E.header) : null, S = M(L), document.addEventListener("click", n, !1), L && C.addEventListener("resize", s, !1), E.updateURL && E.popstate && C.addEventListener("popstate", a, !1)
            }, T.init(e), T
        }
    });

function _() {
    var i = new SmoothScroll('a[href*="#"]', {
        header: "#header"
    });
    new LazyLoad({
        elements_selector: ".lazy"
    });
    document.addEventListener("scroll", function () {
        var e = document.documentElement.scrollTop || document.body.scrollTop,
            t = (document.documentElement.scrollHeight || document.body.scrollHeight) - document.documentElement.clientHeight;
        scrollPercent = e / t * 100, document.getElementById("scroll-progress").setAttribute("value", scrollPercent.toFixed(3))
    }, {
            passive: !0
        });
    var e = document.getElementsByClassName("scrollspy"),
        n = {},
        t = 0;
    setTimeout(function () {
        Array.prototype.forEach.call(e, function (e, t) {
            n[t] = {
                title: e.getAttribute("data-title"),
                offsetTop: e.offsetTop - 64
            }
        })
    }, 100)
    var o = document.getElementById("navMenu");

    function a() {
        o.classList.remove("slideInDown"), o.classList.add("slideOutUp"), setTimeout(function () {
            o.style.display = "none"
        }, 1e3)
    }
    var s = document.getElementsByClassName("main-cta");
    for (t = 0; t < s.length; t++) s[t].addEventListener("click", function (e) {
        e.target.removeEventListener(e.type, arguments.callee), this.classList.add("is-loading")
    });
    var r = 3,
        l = 3,
        c = document.getElementById("load-comments");
    // c.addEventListener("click", function (e) {
    //     this.classList.add("is-loading");
    //     var o = document.querySelectorAll("[data-comment]");
    //     setTimeout(function () {
    //         c.classList.remove("is-loading");
    //         var e = r + (o.length > r + 10 ? r + 10 : o.length - r);
    //         l = r, r = e;
    //         for (var t = 0; t < o.length; t++) {
    //             var n = o[t].getAttribute("data-comment");
    //             parseInt(n) < r && (o[t].style.display = "flex")
    //         }
    //         r === o.length && (c.style.display = "none");
    //         i.animateScroll(o[l - 1], null, {
    //             speed: 1500,
    //             easing: "easeOutCubic"
    //         })
    //     }, 1500)
    // });
}
function currentDate() {
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];       
        var today = new Date();
        var elems = document.getElementsByClassName("Date");
        today.setTime(today.getTime());
        [].slice.call( elems ).forEach(function ( elem ) {
           let twoDaysOut = today.getDate() + 2
            elem.innerHTML = months[today.getMonth()] + " " + twoDaysOut + ", " + today.getFullYear();
        });

        var url = new URL(window.location.href);
        var search_params = new URLSearchParams(url.search); 

        for(var i of search_params) { // iterate over the query parameters
        // i an an array
        // i[0] => name // i[1] => value
        // console.log(i[0] + ' : ' + i[1]);
        }
        var aft = search_params.toString(); // Put urlParams in to variable

        // Loop to get all anchors 
        $("a").each(function() {
            var $this = $(this);       
            var _href = $this.attr("href"); 
            $this.attr("href", _href + '?' + aft); // Append URL params to all links
        });
}
currentDate()
document.addEventListener("DOMContentLoaded", function () {
    _()
});

// article date 7 days ago
const today = new Date();
today.setDate(today.getDate() - 7);
const day = today.getDay();
const d = today.getDate()
const month = today.getMonth();
const year = today.getFullYear();
const daylist = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
const monthlist = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const todayElement = document.getElementsByClassName('c-author')
const todayText = document.createTextNode(`${daylist[day]}, ${monthlist[month]} ${d}, ${year} : Special editorial by Catherine S. Mills`)
todayElement[0].appendChild(todayText)